export const INITIAL_MOCK_STATUSES: Record<string, (number | undefined)[]> = {
    'OrganizationService.getOrganizations': [],
    'AttributionService.getAttributions': [],
    'OrganizationService.getOrganizationAttributions': [],
    'BundleService.getBundles': [],
    'LinkService.getLinks': []
};